import MainContainer from './ui.container';

export { MainContainer };
export default MainContainer;
